<div class="main-container">
    <div class="main-form" (click)="$event.stopPropagation()">
        <div class="dock-details">
            <span>Doca</span>
            <span>{{dockNumber}}</span>
        </div>

        <div class="planned-container">
            <span>Viagens planejadas</span>
            <button (click)="togglePlanning()">
                TIME-TABLE
            </button>
        </div>

        <div class="planned-info">
            <ng-container *ngIf="sharedChassisTrip; else emptyPlan">
                <table>
                    <thead>
                        <tr>
                            <th>VIAGEM</th>
                            <th>PROCESSO</th>
                            <th>CHEGADA SLA</th>
                            <th>SAÍDA SLA</th>
                            <th>EXTRA</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{sharedChassisTrip.trip}}</td>
                            <td>{{sharedChassisTrip.processDescription}}</td>
                            <td>{{sharedChassisTrip.arrivalTimeSLA}}</td>
                            <td>{{sharedChassisTrip.departureTimeSLA}}</td>
                            <td>{{sharedChassisTrip.extra}}</td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>
            <ng-template #emptyPlan>
                <h2 class="empty-data">Nenhuma viagem encontrada</h2>
            </ng-template>
        </div>
        <button class="btn-save" (click)="shareTripData()">Salvar</button>
    </div>
</div>

<app-chassis-time-table *ngIf="timeTableIsVisible" [mode]="'selection'"
    (rowSelected)="handleTripSelection($event)"></app-chassis-time-table>